import React from 'react';

import { TaskBarHeader, TaskBarSkeleton } from 'features/task_bar/TaskBar';
import { WorkflowNrtSkeleton } from 'features/workflow_nrt/WorkflowRecent';

import { BookmarkToolbar } from '../bookmarks/BookmarkToolbar';
import { InfoWalkmeCrumb } from '../info_hover/InfoHover';
import { NRTDatePicker } from '../task_bar/DatePicker';
import { ReliesOn } from '../workflow_common/NoDataLoadedWarning';
import {
  WorkflowInfo,
  maybeCarryOverDates,
} from '../workflow_common/workflowLookup';
import { RealtimeDataProvider } from './RealtimeDataProvider';
import { TimeSlider } from './TimeSlider';
import { TimelineMap } from './TimelineMap';
import { TimelineMetricsOption } from './TimelineMetricsOption';

import tbstyles from '../task_bar/Taskbar.module.css';

export const workflowTimeline: WorkflowInfo = {
  dataAvailableReliesOn: [ReliesOn.nrtDay, ReliesOn.typicalMonth],
  switchToState: (fromWorkflow, state) => {
    // console.log('Handling switch from ', fromWorkflow, 'to', state.current, state);
    maybeCarryOverDates(state, fromWorkflow);
  },
};

export function TimelineTaskBar({
  children: mapSettings,
}: {
  children: React.ReactNode;
}) {
  return (
    <TaskBarSkeleton
      showTitle
      upper={<BookmarkToolbar />}
      middle={null}
      lower={
        <>
          <TaskBarHeader>
            Map Settings <InfoWalkmeCrumb elId="timeline-settings" />
          </TaskBarHeader>
          <div className={tbstyles.task_bar_section_body}>{mapSettings}</div>
          <div className={tbstyles.task_bar_section_filler} />
        </>
      }
    />
  );
}

export function WorkflowTimeline() {
  return (
    <WorkflowNrtSkeleton
      enableScreenshot={false}
      mapComponent={<TimelineMap />}
      vizRegionComponent={<TimeSlider />}
      taskBarComponent={
        <TimelineTaskBar>
          <NRTDatePicker enableDayArrows enableDayRange={false} />
          <RealtimeDataProvider />
          <TimelineMetricsOption />
        </TimelineTaskBar>
      }
    />
  );
}
